import yamlDump from "js-yaml";

// ── Types ────────────────────────────────────────────────────────────────────

export interface ManifestService {
  name: string;
  type: string;
  port?: number;
  internetFacing: boolean;
  image?: string;
  storage?: string;
  command?: string[];
  schedule?: string;
  resources?: { cpu?: string; memory?: string };
  vcs?: {
    baseImage?: string;
    dockerfile?: string;
    buildCommand?: string;
    buildDir?: string;
  };
}

export interface ManifestData {
  apiVersion: string;
  kind: string;
  metadata: {
    name: string;
    project: string;
    org: string;
  };
  spec: {
    template?: string;
    deployMode?: string;
    vcs?: Record<string, unknown>;
    services: ManifestService[];
    environments?: Record<
      string,
      {
        services?: {
          name: string;
          replicas?: number;
          resources?: { cpu?: string; memory?: string };
        }[];
      }
    >;
  };
}

export interface ResolvedService {
  name: string;
  type: string;
  port?: number;
  internetFacing: boolean;
  replicas: number;
  resources: { cpu: string; memory: string };
  image?: string;
  storage?: string;
}

export interface ManifestPreviewResponse {
  manifest: ManifestData;
  resolved: {
    orgAlias: string;
    projectAlias: string;
    systemAlias: string;
    templateSlug?: string;
    vcs?: Record<string, unknown>;
    services: ResolvedService[];
    environment: string;
  };
}

export interface ManifestVersionEntry {
  id: number;
  environment: string;
  version: number;
  gitCommitSha: string | null;
  minioKey: string;
  createdAt: string;
  createdBy: number;
}

export interface ManifestDiffResponse {
  from: string;
  to: string;
}

// ── YAML serialization via js-yaml ─────────────────────────────────────────

export function manifestToYaml(data: ManifestData): string {
  return yamlDump.dump(data, {
    indent: 2,
    lineWidth: 120,
    noRefs: true,
    sortKeys: false,
    quotingType: '"',
    forceQuotes: false,
  });
}

export const ENVIRONMENT_OPTIONS = [
  { value: "production", label: "Production" },
  { value: "staging", label: "Staging" },
  { value: "dev", label: "Development" },
] as const;
